import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=942dc9ae&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('942dc9ae')) {
      api.createRecord('942dc9ae', component.options)
    } else {
      api.reload('942dc9ae', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=942dc9ae&", function () {
      api.rerender('942dc9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b8DZu5Fk4WE6/JS/comp/pricelist.vue"
export default component.exports